import { CombinedGraphQLErrors } from '@apollo/client';
import { ServerError } from '@apollo/client/errors';

const TRANSIENT_CODES = ['UNAVAILABLE', 'DEADLINE_EXCEEDED'];
const TRANSIENT_ERROR_BREADCRUMB = 'Transient server error suppressed from Sentry';

const isTransientServerError = (error: unknown): error is ServerError =>
  ServerError.is(error) && error.statusCode >= 500 && error.statusCode < 600;

const isTransientGraphQLError = (error: { extensions?: Record<string, unknown> }): boolean =>
  TRANSIENT_CODES.includes(error.extensions?.['code'] as string);

const isTransientError = (error: unknown): boolean => {
  if (isTransientServerError(error)) {
    return true;
  }

  if (!CombinedGraphQLErrors.is(error)) {
    return false;
  }

  return error.errors.some(isTransientGraphQLError);
};

export {
  isTransientError,
  isTransientGraphQLError,
  isTransientServerError,
  TRANSIENT_ERROR_BREADCRUMB,
};
